import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Button } from '@beef/legacy-ui-kit';
import { Icon } from "../../../../../../Icon";
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);
var picSrc = '//static.beeline.ru/upload/images/new-shpd-catalog/voprosi/trubka.svg';
export var RenderTechSupport = function RenderTechSupport(_ref) {
  var texts = _ref.texts;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', 'techSupport'),
    "data-t-id": "components-RenderTechSupport"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('desktopOnly')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('techSupportText'),
    dangerouslySetInnerHTML: {
      __html: texts.techSupportText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('techSupportPhoneWrapper')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('techSupportIcon'),
    src: picSrc
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('techSupportPhone'),
    dangerouslySetInnerHTML: {
      __html: texts.techSupportPhone
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('mobileOnly')
  }, /*#__PURE__*/React.createElement(Button, {
    className: ['big', cx('phoneBtn')],
    color: "light",
    href: texts.techSupportPhoneHref
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: texts.techSupportPhone
    },
    "data-t-id": "components-RenderTechSupport"
  }), /*#__PURE__*/React.createElement(Icon, {
    className: cx('phoneBtnIcon'),
    name: "phone-material"
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('techSupportText'),
    dangerouslySetInnerHTML: {
      __html: texts.techSupportText
    }
  })));
};
RenderTechSupport.propTypes = process.env.NODE_ENV !== "production" ? {
  texts: PropTypes.shape({
    techSupportText: PropTypes.string,
    techSupportPhone: PropTypes.string,
    techSupportPhoneHref: PropTypes.string
  })
} : {};